<template>
  <div class="UnlockRecord">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="房间号">
        <el-select v-model="searchForm.apartmentAssetCode"
                   @change="getDataList('search')">
          <el-option v-for="item in homeList"
                     :key="item.apartmentAssetCode"
                     :label="item.apartmentAssetName"
                     :value="item.apartmentAssetCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="设备代码">
        <el-input v-model="searchForm.deviceCode"
                  placeholder="设备代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="item.apartmentCode"
                   v-for="(item, index) in apartmentlist"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
          <el-table-column label="公寓"
                           prop="apartmentName">
          </el-table-column>
          <el-table-column label="房间"
                           prop="apartmentAssetName">
          </el-table-column>
          <el-table-column label="开锁人"
                           prop="userName">
          </el-table-column>
          <el-table-column label="设备代码"
                           prop="devCode">
          </el-table-column>
          <el-table-column label="用户类型"
                           prop="localUserName">
          </el-table-column>
          <el-table-column label="开锁时间"
                           prop="openTime">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">查看
              </el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>

      </el-tab-pane>
    </el-tabs>

    <!-- 开锁信息详情 -->
    <el-dialog title="开锁信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="公寓："
                      prop="apartmentName">
          <span>{{ detailForm.apartmentName }}</span>
        </el-form-item>
        <el-form-item label="房间："
                      prop="apartmentAssetName">
          <span>{{ detailForm.apartmentAssetName }}</span>
        </el-form-item>
        <el-form-item label="设备代码："
                      prop="devCode">
          <span>{{ detailForm.devCode }}</span>
        </el-form-item>
        <el-form-item label="用户类型："
                      prop="localUserName">
          <span>{{ detailForm.localUserName }}</span>
        </el-form-item>
        <el-form-item label="开锁时间："
                      prop="openTime">
          <span>{{ detailForm.openTime }}</span>
        </el-form-item>
        <el-form-item label="开锁人："
                      prop="openTime">
          <span>{{ detailForm.userName }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/UnlockRecord.css'
export default {
  data() {
    return {
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 0,
      pageSize: 10,
      totalPage: 1,
      detailDialog: false,
      detailForm: {},
      activeName: '',
      apartmentCode:'',
      apartmentlist: [],
      homeList: [],
    }
  },

  computed: {},

  created() {
    let self = this

    // self.getDataList()
    self.getApartmentlist()
  },

  mounted() {
  },

  methods: {
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    handleClick(tab, event) {
      let self = this

      self.apartmentCode = tab.name

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 1,
      }
      self.getHomeList(str)
    },

    // 获取公寓列表
    getApartmentlist() {
      let self = this

      self.$axios
        ._getApartmentlist()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.apartmentlist = datas.data

            self.activeName = self.apartmentlist[0].apartmentCode
            self.apartmentCode = self.apartmentlist[0].apartmentCode

            let str = {
              apartmentCode: self.apartmentlist[0].apartmentCode,
              flag: 1,
            }
            self.getHomeList(str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取房间列表
    getHomeList(fristApartment) {
      let self = this

      let str = fristApartment

      self.$axios
        ._getHomelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.homeList = datas.data.content
            self.searchForm.apartmentAssetCode =
              self.homeList[0].apartmentAssetCode

            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      self.dataListLoading = true

      if (type == 'search') {
        self.pageIndex = 0
      }

      let str = {
        devCode: self.searchForm.deviceCode || '',
        apartmentCode:self.apartmentCode,
        apartmentAssetCode:self.searchForm.apartmentAssetCode,
        pageNow: self.pageIndex,
        pageSize: self.pageSize,
      }

      self.dataList = []

      self.$axios
        ._getLockRecordList(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.content
            self.totalPage = datas.data.totalElements
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 开锁信息弹窗
    openDetailDialog: function (row) {
      let self = this

      self.detailForm = row

      self.detailDialog = true
    },

    // 关闭 开锁信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除开锁记录
    handleDelete(row) {
      let self = this

      let id = row.id
      let deviceCode = row.devCode

      // let str = `?ids=${ids}&deviceCode=${deviceCode}&`
      let str = `?id=${id}`

      self
        .$confirm(`是否确认要删除 "${row.userName}" 的开锁记录？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delLockRecord(str)
        })
        .then((data) => {
        })
    },

    delLockRecord(code) {
      let self = this

      self.$axios
        ._deleteLockRecord(code)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/UnlockRecord.vue